import { useNavigate } from 'react-router-dom';

import { AppIcon, ContentNugget, Employer } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { NuggetSection } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/NuggetSection';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

import { Box, Button, Theme, SxProps } from '@mui/material';

type PeopleSectionProps = Readonly<{
  employer: Employer;
  people: ContentNugget[];
  isLoading: boolean;
}>;

const SECTION_STRINGS = appStrings.modules.employer.people;

export const PeopleSection = ({ employer, people, isLoading }: PeopleSectionProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleNuggetClick = (nugget: ContentNugget) => {
    dispatch(setCurrentDialogNugget(nugget));
  };

  return (
    <Box>
      <NuggetSection
        title={SECTION_STRINGS.title}
        description={SECTION_STRINGS.description(employer.name)}
        nuggets={people}
        onNuggetClick={handleNuggetClick}
        loading={isLoading}
        headerButton={
          <Button
            sx={buttonStyle}
            hierarchy="Secondary gray"
            size="md"
            startIcon={<AppIcon iconName="MessageChatCircle" diameter="20px" color="Gray/700" />}
            onClick={() => navigate(`${APP_ROUTE.COMPETENCY}/careers-networking`)}
          >
            {SECTION_STRINGS.networkCompetency}
          </Button>
        }
      />
    </Box>
  );
};

const buttonStyle: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-lg'],
});
